import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terminosycondiciones',
  templateUrl: './terminosycondiciones.component.html',
  styleUrls: ['./terminosycondiciones.component.css']
})
export class TerminosycondicionesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
